import { z } from 'zod';

export const cdekDeliveryPointRawSchema = z
    .object({
        code: z.string(),
        name: z.string(),
        location: z.object({
            address: z.string().optional(),
            address_full: z.string().optional(),
            latitude: z.union([z.number(), z.string().transform(Number)]),
            longitude: z.union([z.number(), z.string().transform(Number)]),
            city: z.string().optional(),
            postal_code: z.string().optional(),
        }),
        work_time: z.string().optional(),
        phones: z.array(z.object({ number: z.string() })).optional(),
    })
    .passthrough();

export type CdekDeliveryPointRawSchema = z.infer<typeof cdekDeliveryPointRawSchema>;
